import React, { useState } from 'react';
import { PageHeader } from '../../components/UI';
import DashboardTab from './tabs/DashboardTab';
import ListTab from './tabs/ListTab';
import CreateTab from './tabs/CreateTab';
import DetailTab from './tabs/DetailTab';

const ProcurementPage = () => {
  const [tab, setTab] = useState('dashboard');
  const [editId, setEditId] = useState(null);

  const tabs = [
    { id: 'dashboard', label: 'Dashboard' },
    { id: 'list', label: 'Daftar PR' },
    { id: 'create', label: 'Buat PR Baru' },
  ];

  const handleEdit = (id) => { setEditId(id); setTab('detail'); };
  const handleNew = () => { setEditId(null); setTab('create'); };

  return (
    <div>
      <PageHeader title="BALAKADA — Manajemen Pengadaan" subtitle="Permintaan barang, SIRUP checklist, routing Tender/Langsung, dan purchase order" />
      <div style={{ display: 'flex', gap: 8, marginBottom: 24, borderBottom: '1px solid #E5E7EB', overflowX: 'auto' }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding: '12px 16px', borderBottom: tab === t.id ? '2px solid #2563EB' : 'none', color: tab === t.id ? '#2563EB' : '#6B7280', fontWeight: tab === t.id ? 600 : 500, border: 'none', background: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
            {t.label}
          </button>
        ))}
        {tab === 'detail' && (
          <button onClick={() => setTab('detail')} style={{ padding: '12px 16px', borderBottom: '2px solid #2563EB', color: '#2563EB', fontWeight: 600, border: 'none', background: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
            Detail PR
          </button>
        )}
      </div>

      {tab === 'dashboard' && <DashboardTab />}
      {tab === 'list' && <ListTab onEdit={handleEdit} onNew={handleNew} />}
      {tab === 'create' && <CreateTab onSuccess={() => setTab('list')} />}
      {tab === 'detail' && <DetailTab id={editId} onBack={() => { setTab('list'); setEditId(null); }} />}
    </div>
  );
};

export default ProcurementPage;